import Button from '../ui/Button/Button'
import SocialLinks from '../ui/SocialLinks/SocialLinks'
import { ArrowDownIcon, ArrowRightIcon } from '../ui/Icon/Icon'
import { about, social } from '../../data/portfolio'
import styles from './Hero.module.css'

const Hero = () => {
  const { name, role, tagline, status, resume } = about

  return (
    <section className={styles.hero} aria-labelledby="hero-heading">
      <div className={styles.backdrop} aria-hidden="true">
        <div className={styles.grid} />
        <div className={styles.glow} />
      </div>

      <div className={`container ${styles.inner}`}>
        {status && (
          <p className={styles.status}>
            <span className={styles.statusDot} aria-hidden="true" />
            {status}
          </p>
        )}

        <p className={styles.intro}>Hi, I&rsquo;m {name.split(' ')[0]}</p>

        <h1 id="hero-heading" className={styles.heading}>
          {name}
        </h1>

        <p className={styles.role}>{role}</p>

        <p className={styles.tagline}>{tagline}</p>

        <div className={styles.actions}>
          <Button href="#projects" className={styles.cta}>
            View my work
            <ArrowRightIcon size={18} />
          </Button>

          {resume ? (
            <Button href={resume} variant="outline" className={styles.cta}>
              Download CV
            </Button>
          ) : (
            <Button
              href={`mailto:${social.email}`}
              variant="outline"
              className={styles.cta}
            >
              Get in touch
            </Button>
          )}

          <SocialLinks className={styles.social} />
        </div>
      </div>

      <a href="#about" className={styles.scrollCue} aria-label="Scroll to About">
        <span className={styles.scrollLabel}>Scroll</span>
        <ArrowDownIcon size={16} />
      </a>
    </section>
  )
}

export default Hero
